import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GS1NotificationService } from "@gs1france/gs1-components-library";
import { Contact, ContactInfo } from "../../../models/contact.model";
import { environment } from '../../../../environments/environment';
import { lastValueFrom } from "rxjs";

/**
 * Service that handle Contact and CGUs operations
 */
@Injectable({providedIn: 'root'})
export class ContactService {

  constructor(private http: HttpClient, private notifications: GS1NotificationService) {}

  /**
   * Get the contact information of the user.
   * @returns {Promise<Contact>}
   */
  async getInfoContact() {
    try {
      const todayDate = new Date(new Date().setHours(0,0,0,0))
      var isAccountabilityPeriod = todayDate >= new Date(environment.ACCOUNTING_PERIOD.start_date) &&
                                   todayDate <=new Date(environment.ACCOUNTING_PERIOD.end_date);
      const contact: ContactInfo = await lastValueFrom(this.http.get<ContactInfo>(`${environment.URL_Back}Contact?isAccountabilityPeriod=${isAccountabilityPeriod}`));
      return contact;
    } catch (err) {
      this.handleErrors(err, 'Les données de votre compte n\'ont pas pu être chargées.');
      throw err;
    }
  }

  /**
   * Accept the CGU for the user and company.
   * @returns None
   */
  async acceptCGU(): Promise<string> {
    try {
      const acceptanceDate = (new Date()).toISOString()
      await lastValueFrom(this.http.post(`${environment.URL_Back}Contact/AcceptCgu`, {acceptanceDate}));
      return acceptanceDate;
    } catch (err) {
      this.handleErrors(err, 'L\'acceptation des CGU n\'a pas abouti.');
      throw err;
    }
  }

  async dontShowNonPayerPopin(): Promise<boolean> {
    try {
      await lastValueFrom(this.http.post(`${environment.URL_Back}Contact/DontShowNonPayerPopin`,null));
      return true;
    } catch (err) {
      this.handleErrors(err, 'L\'enregistrement n\'a pas abouti.');
      throw err;
    }
  }

  async loginuser(): Promise<string> {
    try {
      const acceptanceDate = ""
      await lastValueFrom(this.http.post(`${environment.URL_Back}Contact/Login`, {acceptanceDate}));
      return acceptanceDate;
    } catch (err) {
      this.handleErrors(err, 'L\'acceptation des CGU n\'a pas abouti.');
      throw err;
    }
  }


  /**
   * Handles errors by logging them to the console and adding a notification if a message is provided.
   * @param {any} err - the error object.
   * @param {string} [msg] - the message to display in the notification.
   * @returns None
   */
  handleErrors(err: any, msg?: string) {
    if (msg) {
      this.notifications.addNotification(msg, 'error');
    }
    console.error(err);
    throw err;
  }
}
